import {
  collection,
  doc,
  getFirestore,
  onSnapshot,
  setDoc,
} from 'firebase/firestore';
import { action, computed, flow, observable, reaction } from 'mobx';
import MobxState from '../../abstract/MobxState';
import { createObservableInstance } from '../../helpers';

class UserImplDependedRefState extends MobxState {
  constructor(root, { pathGetter, collection: { ItemClass } = {} }) {
    super(root);

    // this.options = {
    //   pathGetter,
    //   ItemClass,
    // };
    //
    this.pathGetter = pathGetter;
    this.ItemClass = ItemClass;
    this.isCollection = !!ItemClass;
  }

  error = '';

  snapshot = null;

  snapshotDestroy_ = null;

  get data() {
    return this.isCollection
      ? this.snapshot?.docs.map((doc) =>
          createObservableInstance(this.ItemClass, this, { snapshot: doc })
        )
      : this.snapshot?.data();
  }

  get isInitialized() {
    return !!this.snapshotDestroy_ && (this.error || this.snapshot);
  }

  get ref() {
    return this.snapshot?.ref;
  }

  get path() {
    return this.root.userImpl ? this.pathGetter(this.root.userImpl) : '';
  }

  init() {
    super.init();

    this.reactions_.push(
      reaction(
        () => this.path,
        () => this.handlePathChange()
      )
    );
  }

  handlePathChange() {
    this.snapshotDestroy_?.();
    console.log('handlePathChange___________', this.path);
    if (this.path) {
      this.snapshotDestroy_ = onSnapshot(
        this.isCollection
          ? collection(getFirestore(), this.path)
          : doc(getFirestore(), this.path),
        (snapshot) => this.handleSnapshotSuccess(snapshot),
        (error) => this.handleSnapshotError(error)
      );
    } else {
      this.snapshot = null;
      this.error = null;
      this.snapshotDestroy_ = null;
    }
  }

  handleSnapshotError(error) {
    this.error = error.message;
  }

  handleSnapshotSuccess(snapshot) {
    this.error = '';
    this.snapshot = snapshot;
  }

  *update(data) {
    if (this.isCollection) return Promise.reject('Cannot update a collection');
    if (!this.path) return Promise.reject('Not initialized');

    const ref = this.ref || doc(getFirestore(), this.path);

    this.isUpdating = true;
    try {
      const result = yield setDoc(ref, data, { merge: true });
      this.isUpdating = false;
      return result;
    } catch (e) {
      this.isUpdating = false;
      return Promise.reject(e);
    }
  }

  destroy() {
    super.destroy();

    this.snapshotDestroy_?.();
    this.snapshotDestroy_ = null;
    this.error = null;
  }
}

UserImplDependedRefState.annotations = {
  ...MobxState.annotations,
  error: observable,
  snapshot: observable.ref,
  snapshotDestroy_: observable.ref,
  data: computed,
  handleSnapshotError: action,
  handleSnapshotSuccess: action,
  ref: computed,
  update: flow,
  path: computed,
};

export default UserImplDependedRefState;
